import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AboutSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const context = gsap.context(() => {
      const textElements = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".animated-text-content")
      );

      // --- 1. Scrubbed Text Reveal Animation (Merise.ae style) ---
      textElements.forEach((element, index) => {
        // Set Initial State: Hidden (opacity: 0), slightly down (y: 25), and clipped from the bottom
        gsap.set(element, {
          y: 25,
          opacity: 0,
          clipPath: "inset(100% 0 0% 0)",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: element.closest("div"),
            start: "top 85%", // Animation shuru karo jab element screen mein aana shuru ho
            end: "center 60%", // Animation end karo jab element screen mein lagbhag center ho
            scrub: 1, // Scroll se smooth link (scrubbing)
            // markers: true,
          },
        });

        // Define the Target State: Visible (opacity: 1), original position (y: 0), and fully unclipped
        // Scroll down karne par (timeline forward), text 25px se 0px par aayega (Neeche se Upar).
        tl.to(element, {
          y: 0, // Final state: Original position
          opacity: 1,
          clipPath: "inset(0% 0 0% 0)", // Fully visible
          duration: 1,
          ease: "power2.out", // Thoda smooth movement
          delay: index * 0.1, // Stagger effect for line-by-line reveal
        });
      });

      // --- 2. Scrubbed Divider Line Animation (Grow from Left) ---
      const lineElement = sectionRef.current.querySelector(
        ".about-divider-line"
      );
      if (lineElement) {
        // Initial State: Hidden (scaleX: 0) and set origin to the left
        gsap.set(lineElement, { scaleX: 0, transformOrigin: "left" });

        gsap.to(lineElement, {
          scaleX: 1, // Target state is visible (full width)
          duration: 1,
          ease: "none",
          scrollTrigger: {
            trigger: lineElement.closest(".about-subtitle"),
            start: "top 85%",
            end: "center 60%",
            scrub: 1,
          },
        });
      }
    }, sectionRef);

    return () => context.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full max-w-[1620px] mx-auto flex flex-col gap-[25px] sm:gap-[37px] 2xl:gap-[50px] justify-start items-center mt-[48px] sm:mt-[72px] 2xl:mt-[96px] px-[32px] sm:px-6 lg:px-8"
    >
      <div className="flex flex-col gap-[11px] sm:gap-[16px] 2xl:gap-[22px] justify-start items-start w-full">
        {/* 1. Subtitle */}
        <div className="flex flex-row justify-start items-center w-full about-subtitle overflow-hidden">
          <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-[#1c233a] font-[Sora] animated-text-content">
            About Us
          </p>

          <div className="w-[100px] sm:w-[150px] 2xl:w-[200px] h-[1px] sm:h-[1.5px] 2xl:h-[2px] bg-[#1c233a] ml-[15px] sm:ml-[22px] 2xl:ml-[30px] mb-[7px] sm:mb-[10px] 2xl:mb-[14px] self-end about-divider-line"></div>
        </div>
        {/* 2. Title Line 1 */}
        <div className="about-title-1 overflow-hidden">
          <h2 className="text-[30px] sm:text-[45px] 2xl:text-[60px] font-bold  text-left text-[#1c233a] font-[Sora] animated-text-content">
            Pioneering Sustainability
            <br />
            in Agriculture & Energy
          </h2>
        </div>
        {/* 3. Title Line 2 */}
        {/* <div className="about-title-2 overflow-hidden">
          <h2 className="text-[30px] sm:text-[45px] 2xl:text-[60px] font-bold leading-[38px] sm:leading-[57px] 2xl:leading-[76px] text-left text-[#1c233a] font-[Sora] animated-text-content"></h2>
        </div> */}
        {/* 4. Paragraph */}
        <div className="about-paragraph overflow-hidden">
          <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-[#1c233a] font-[Sora] w-[100%] md:w-[74%] animated-text-content">
            Providing innovative organic fertilizers and bio gas solutions to
            promote sustainability, enhance soil health, reduce carbon
            footprint, support renewable energy, and create a greener future for
            agriculture and environmental well-being worldwide.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
